import { render, staticRenderFns } from "./MixAdd.vue?vue&type=template&id=4dd8fbcb&scoped=true&"
import script from "./MixAdd.vue?vue&type=script&lang=js&"
export * from "./MixAdd.vue?vue&type=script&lang=js&"
import style0 from "./MixAdd.vue?vue&type=style&index=0&id=4dd8fbcb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd8fbcb",
  null
  
)

export default component.exports